import moment from 'moment';
import { toLower } from 'ramda';
import React from 'react';
import '../../assets/assistance-queue.scss';
import { getQueueTextByBackgroundColor } from '../../pages/Tasks/Terminal/utils/terminalAssistanceQueueColors.functions';
import {
  CapacityCategory,
  CapacityCategoryQueueHeaderStyle,
} from '../../types/capacityCategory.types';
import { DocumentTypeStyle } from '../../types/documentType.types';
import { Task } from '../../types/task.types';

type Props = {
  data?: Task[];
  color?: string | null;
  category: CapacityCategory;
};

const injectStyle = (style) => {
  const styleElement = document.createElement('style');
  let styleSheet: CSSStyleSheet | null = null;
  document.head.appendChild(styleElement);
  styleSheet = styleElement.sheet;
  if (styleSheet) styleSheet.insertRule(style, styleSheet.cssRules.length);
};

export default function AssistanceDataGrid({ data, category, color }: Props) {
  const items = data?.slice(0, 3);
  const timeItem = [{ id: 0, assistancePanelQueueDisplayName: moment().format('HH:mm') }];

  const RowItem = ({ data }: { data: Task }) => {
    const _color = data.typeColorName || color;
    const textColor = _color ? getQueueTextByBackgroundColor(toLower(_color!)) : null;
    const existItems = items && items?.length > 0;
    const style: DocumentTypeStyle = data.typeStyle ? JSON.parse(data.typeStyle) : null;

    if (style && style.blinking) {
      const blinkBgStyle = `.assistance-blink-bg { animation: blinkingBackground ${style.blinking.time}s infinite;}`;
      const keyframesStyle = `
        @keyframes blinkingBackground {
          0%   { background-color: ${style.blinking.color1}; }
          25%  { background-color: ${style.blinking.color2}; }      
          50%  { background-color: ${style.blinking.color1}; }      
          75%  { background-color: ${style.blinking.color2}; }
          100% { background-color: ${style.blinking.color1}; }
        }
      `;
      injectStyle(blinkBgStyle);
      injectStyle(keyframesStyle);
    }

    const durationFromCreated = moment.duration(moment().diff(data.created));
    let hours: string | number = durationFromCreated.days() * 24 + durationFromCreated.hours();
    let minutes: string | number = durationFromCreated.minutes();
    if (hours <= 9) hours = `0${hours}`;
    if (minutes <= 9) minutes = `0${minutes}`;

    let titleStyle: any = { textAlign: existItems ? 'left' : 'center' };
    let taskCreatedStyle: any;
    if (existItems && textColor) {
      const color = `rgba(${textColor[0]}, ${textColor[1]}, ${textColor[2]}, ${textColor[3]})`;
      titleStyle = {
        ...titleStyle,
        color: color,
      };
      taskCreatedStyle = { color: color };
    }

    return (
      <div
        className={`assistance-row-item queue-row-${existItems ? items?.length : `full`}${
          style
            ? ' assistance-blink-bg'
            : _color
            ? ` assistance-${existItems ? '' : 'text-'}${toLower(_color)}_row-bg`
            : ` assistance-${existItems ? '' : 'text-'}default_row-bg`
        }`}
        style={
          style
            ? {
                color: existItems ? style.color : 'red',
                backgroundColor: existItems ? style.backgroundColor : '#efefef',
                justifyContent: existItems ? 'left' : 'center',
              }
            : undefined
        }
      >
        <div className="task-title" style={titleStyle}>
          {data.assistancePanelQueueDisplayName}
        </div>
        {existItems && (
          <div className="task-created" style={taskCreatedStyle}>{`${hours}:${minutes}`}</div>
        )}
      </div>
    );
  };

  const dataSource = items && items.length > 0 ? items : timeItem;

  const ccHeaderStyle = category.assistanceQueueHeaderStyle
    ? JSON.parse(category.assistanceQueueHeaderStyle)
    : null;
  const _color = category.colorName || null;

  let headerStyleDefault: CapacityCategoryQueueHeaderStyle = {
    color: ccHeaderStyle?.color ? ccHeaderStyle.color : `#959595`,
    fontSize: ccHeaderStyle?.fontSize ? ccHeaderStyle.fontSize : `14px`,
    // @ts-ignore
    textAlign: ccHeaderStyle?.textAlign ? ccHeaderStyle.textAlign : `left`,
    fontWeight: ccHeaderStyle?.fontWeight ? ccHeaderStyle.fontWeight : `600`,
  };

  return (
    <div className="assistance-table">
      <div
        className={`assistance-table-header${
          _color && !ccHeaderStyle?.color ? ` ${toLower(_color)}` : ``
        }`}
        style={headerStyleDefault}
      >
        {category?.name || ''}
      </div>
      {dataSource?.map((item, idx) => (
        // @ts-ignore
        <RowItem key={idx} data={item} />
      ))}
    </div>
  );
}
